<div class="card">
    <p-fieldset class="title-legend" legend="Informações da receita">
        <div class="formgrid grid m-0">
            <div class="field col-3 md:col-4 lg:col-4">
                <label for="">OS</label>
                <input class="w-full p-inputtext-sm" pInputText maxlength="100" [(ngModel)]="dadosForm.numeroOS" (blur)="checarNumeroOS()" [disabled]="os_numero_readonly" />
            </div>

            <div class="field col-9 md:col-8 lg:col-8">
                <div class="formgrid grid m-0">
                    <div class="field col-12 md:col-6">
                        <div>
                            <label for="">Paciente</label>
                            <app-table-select
                                [(ngModel)]="dadosForm.paciente"
                                [suggestions]="pacientes"
                                [columns]="colunasPacientes"
                                optionLabel="nome_completo"
                                (completeMethod)="buscarPacientes($event)"
                                [loading]="loadingPacientes"
                                [delay]="500"
                                placeholder="Pesquise um paciente..."
                                searchPlaceholder="Buscar por Nome ou CPF..."
                                dialogHeader="Selecionar Paciente"
                                emptyMessage="Nenhum paciente encontrado"
                                [showClear]="true"
                                [style]="{'width':'100%'}">
                            </app-table-select>
                        </div>
                    </div>
                    <div class="field col-12 md:col-6">
                        <div>
                            <label for="">Médico</label>
                            <app-table-select
                                [(ngModel)]="dadosForm.medico"
                                [suggestions]="medicos"
                                [columns]="colunasMedicos"
                                optionLabel="nome"
                                (completeMethod)="buscarMedicos($event)"
                                [loading]="loadingMedicos"
                                [delay]="500"
                                placeholder="Pesquise um médico..."
                                searchPlaceholder="Buscar por Nome..."
                                secondarySearchPlaceholder="Buscar por CRM..."
                                secondarySearchLabel="CRM"
                                dialogHeader="Selecionar Médico"
                                emptyMessage="Nenhum médico encontrado"
                                [showClear]="true"
                                [style]="{'width':'100%'}">
                            </app-table-select>
                            <div class="flex flex-row gap-1 mt-2">
                                <p-button class="btn-bg-primary" label="Novo" (click)="novoMedico()"></p-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="field col-12 md:col-4 lg:col-3">
                <label>Data Receita</label>
                <p-calendar [showButtonBar]="true" [(ngModel)]="dadosForm.DtReceita" (onInput)="maskDate($event)" dateFormat="dd/mm/yy" [showIcon]="true" [maxDate]="maxDate" [style]="{'width':'100%'}" [styleClass]="'p-inputtext-sm text-sm p-datepicker-sm'"></p-calendar>
            </div>
            <div class="field col-12 md:col-4 lg:col-3">
                <label>Previsão Entrega</label>
                <p-calendar [showButtonBar]="true" [(ngModel)]="dadosForm.DtPrevisaoEntrega" (onInput)="maskDate($event)" dateFormat="dd/mm/yy" [showIcon]="true" [minDate]="maxDate" [style]="{'width':'100%'}" [styleClass]="'p-inputtext-sm text-sm p-datepicker-sm'"></p-calendar>
            </div>
        </div>

        <h4 [style]="{ 'margin': '0 0 1.5rem .75rem' }">Selecione o olho para informar os dados da receita</h4>

        <div class="card flex">
            <div class="flex flex-wrap gap-1 md:gap-3 xl:gap-3 text-sm option-olho">
                <div class="flex align-items-center">
                    <p-radioButton name="olho" value="olho_direito" [(ngModel)]="dadosForm.opcaoOlhoSelecionado" inputId="olho_direito" (click)="verificarProduto('D')"></p-radioButton>
                    <label for="olho_direito" class="ml-2">Olho direito</label>
                </div>

                <div class="flex align-items-center">
                    <p-radioButton name="olho" value="olho_esquerdo" [(ngModel)]="dadosForm.opcaoOlhoSelecionado" inputId="olho_esquerdo" (click)="verificarProduto('E')"></p-radioButton>
                    <label for="olho_esquerdo" class="ml-2">Olho esquerdo</label>
                </div>

                <div class="flex align-items-center">
                    <p-radioButton name="olho" value="ambos" [(ngModel)]="dadosForm.opcaoOlhoSelecionado" inputId="ambos" (click)="verificarProduto()"></p-radioButton>
                    <label for="ambos" class="ml-2">Ambos</label>
                </div>
            </div>
        </div>

        <app-novo-pedido-olho [laboratorioSelecionado]="laboratorioSelecionado" [titulo]="'Olho direito'"  [olho]="dadosForm.olhoDireito"  [produtosLentes]="produtosLentes" *ngIf="dadosForm.opcaoOlhoSelecionado === 'olho_direito' || dadosForm.opcaoOlhoSelecionado === 'ambos'"  (DNPLongeChange)="DnpLongeDireitoChange($event)"  (ProdutoChange)="changeProduto($event, 'D')" class="cp-olho-esquerdo"></app-novo-pedido-olho>

        <app-novo-pedido-olho [laboratorioSelecionado]="laboratorioSelecionado" [titulo]="'Olho esquerdo'" [olho]="dadosForm.olhoEsquerdo" [produtosLentes]="produtosLentes" *ngIf="dadosForm.opcaoOlhoSelecionado === 'olho_esquerdo' || dadosForm.opcaoOlhoSelecionado === 'ambos'" (DNPLongeChange)="DnpLongeEsquerdoChange($event)" (ProdutoChange)="changeProduto($event, 'E')"                         ></app-novo-pedido-olho>

    </p-fieldset>
    
    <p-fieldset class="title-legend" legend="Dados da armação">
        <div class="formgrid grid m-0">
            <div class="field col-12">
                <label>Tipo de montagem</label>
                <p-dropdown inputId="tipo_montagem" class="p-inputtext-sm" [options]="tiposMontagem" [(ngModel)]="dadosForm.armacao.tipoMontagem" placeholder="Selecione o tipo de montagem" optionLabel="nome" [showClear]="true" [style]="{'width':'100%'}" [styleClass]="'p-inputtext-sm'"></p-dropdown>
            </div>
        </div>

        <div class="p-fluid formgrid m-0 grid">
            <div class="flex-auto field col-6 md:col-4 lg:col-1">
                <label>Ponte</label>
                <p-inputNumber class="p-inputtext-sm" [(ngModel)]="dadosForm.armacao.armacaoPonte" (onInput)="armacaoChange($event)"> </p-inputNumber>
            </div>

            <div class="flex-auto field col-6 md:col-4 lg:col-1">
                <label>Aro</label>
                <p-inputNumber class="p-inputtext-sm" [(ngModel)]="dadosForm.armacao.armacaoAro" (onInput)="armacaoChange($event)"> </p-inputNumber>
            </div>

            <div class="flex-auto field col-6 md:col-4 lg:col-2">
                <label>Altura vertical</label>
                <p-inputNumber class="p-inputtext-sm" [(ngModel)]="dadosForm.armacao.armacaoAltVertical" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="5"> </p-inputNumber>
            </div>

            <div class="flex-auto field col-6 md:col-4 lg:col-2">
                <label>Diagonal maior</label>
                <p-inputNumber class="p-inputtext-sm" [(ngModel)]="dadosForm.armacao.armacaoDiagMaior" (onInput)="armacaoChange($event)"> </p-inputNumber>
            </div>

            <div class="flex-auto field col-6 md:col-4 lg:col-2">
                <label>Diâmetro apurado</label>
                <p-inputNumber class="p-inputtext-sm" [(ngModel)]="dadosForm.armacao.armacaoDiamApurado" mode="decimal" [disabled]="true"> </p-inputNumber>
            </div>

            <div class="flex-auto field col-6 md:col-4 lg:col-2">
                <label>Distância pupilar</label>
                <input type="text" class="inputP" (input)="formatarInput($event.target)"[(ngModel)]="dadosForm.armacao.armacaoDistPupilar" [maxlength]="maxlength"/>
            </div>
        </div>
    </p-fieldset>

    <p-fieldset class="title-legend" legend="Anexos">
        <div class="anexos-existentes" *ngIf="anexosExistentes.length">
            <h4>Anexos já enviados</h4>
            <div class="anexos-grid">
                <a *ngFor="let anexo of anexosExistentes" class="anexo-item" [href]="anexo.url" [download]="anexo.nome_arquivo" target="_blank" [title]="anexo.nome_arquivo">
                    <p-button class="anexo-remover" icon="pi pi-times" [rounded]="true" [text]="true" severity="danger" (click)="$event.preventDefault(); $event.stopPropagation(); removerAnexoExistente.emit(anexo)" title="Remover anexo"></p-button>
                    <img *ngIf="anexo.isImagem" [src]="anexo.url" [alt]="anexo.nome_arquivo">
                    <i *ngIf="!anexo.isImagem" class="pi pi-file anexo-icone"></i>
                    <span class="anexo-nome">{{ anexo.nome_arquivo }}</span>
                </a>
            </div>
        </div>

        <p-fileUpload #fileUpload [maxFileSize]="1024 * 1024 * 8" [fileLimit]="5" [invalidFileSizeMessageDetail]="'Tamanho máximo de arquivo excedido (8 MB)'" [invalidFileLimitMessageDetail]="'Número máximo de 5 arquivos excedido.'" [multiple]="true" (onSelect)="onAnexosSelect($event)" (onRemove)="onAnexosRemove($event)" (onClear)="onAnexosClear($event)" chooseLabel="Selecionar" uploadLabel="Enviar" cancelLabel="Limpar" [showUploadButton]="false">

        </p-fileUpload>
    </p-fieldset>

    <app-novo-pedido-outros-servicos [legend]="'Itens'" [servicosAdicionados]="servicosAdicionados" [laboratorioSelecionado]="laboratorioSelecionado"></app-novo-pedido-outros-servicos>

</div>

<p-dialog header="Header" [(visible)]="modalCadastrarMedico" class="width-modal inputs-uppercase" [closable]="!loadingMedico">
    <ng-template pTemplate="header">
        <div class="inline-flex align-items-center justify-content-center gap-2">
            <span class="font-bold white-space-nowrap">Novo médico</span>
        </div>
    </ng-template>

    <p-progressSpinner *ngIf="loadingMedico" class="flex flex-column justify-content-center align-items-center"></p-progressSpinner>
    <div *ngIf="!loadingMedico">
        <p-fieldset class="title-legend" legend="Cadastro de Médico" [style]="{'margin-bottom': '.5rem'}">
            <div class="formgrid grid m-0 p-fluid">
                <!-- Pessoa (readonly) -->
                <div class="field col-12 lg:col-2 mb-2">
                    <label>Pessoa</label>
                    <input pInputText type="text" value="Pessoa Física" [disabled]="true" class="inputP">
                </div>

                <!-- Gênero -->
                <div class="field col-12 lg:col-3 mb-2">
                    <label>Gênero</label>
                    <p-dropdown
                        [(ngModel)]="dadosMedico.genero"
                        [options]="listagemGeneros"
                        optionLabel="descricao"
                        optionValue="id"
                        [showClear]="true"
                        placeholder="Selecione"
                        [styleClass]="'p-inputtext-sm w-full'">
                    </p-dropdown>
                </div>

                <!-- CRM -->
                <div class="field col-12 lg:col-3 mb-2">
                    <label>CRM <span style="color: red;">*</span></label>
                    <input [(ngModel)]="dadosMedico.crm" pInputText type="text" class="inputP" maxlength="20">
                </div>

                <!-- Aniversário Dia -->
                <div class="field col-12 lg:col-2 mb-2">
                    <label>Aniversário Dia</label>
                    <input [(ngModel)]="dadosMedico.aniversario_dia" pInputText type="number" class="inputP" min="1" max="31">
                </div>

                <!-- Aniversário Mês -->
                <div class="field col-12 lg:col-2 mb-2">
                    <label>Aniversário Mês</label>
                    <input [(ngModel)]="dadosMedico.aniversario_mes" pInputText type="number" class="inputP" min="1" max="12">
                </div>

                <!-- Nome Completo -->
                <div class="field col-12 lg:col-8 mb-2">
                    <label>Nome Completo <span style="color: red;">*</span></label>
                    <input [(ngModel)]="dadosMedico.nome" pInputText type="text" class="inputP" maxlength="120">
                </div>

                <!-- Nome Social -->
                <div class="field col-12 lg:col-4 mb-2">
                    <label>Nome Social</label>
                    <input [(ngModel)]="dadosMedico.nome_social" pInputText type="text" class="inputP" maxlength="120">
                </div>

                <!-- Contato -->
                <div class="field col-12 lg:col-3 mb-2">
                    <label>Contato</label>
                    <input [(ngModel)]="dadosMedico.contato" pInputText type="text" class="inputP" maxlength="120" placeholder="ex: Secretaria">
                </div>

                <!-- Telefone -->
                <div class="field col-12 lg:col-3 mb-2">
                    <label>Telefone</label>
                    <p-inputMask class="p-inputtext-sm" mask="(99) 9999-9999" [(ngModel)]="dadosMedico.telefone" />
                </div>

                <!-- Celular -->
                <div class="field col-12 lg:col-3 mb-2">
                    <label>Celular</label>
                    <p-inputMask class="p-inputtext-sm" mask="(99) 9 9999-9999" [(ngModel)]="dadosMedico.celular" />
                </div>

                <!-- E-mail -->
                <div class="field col-12 lg:col-3 mb-2">
                    <label>E-mail</label>
                    <input class="p-inputtext-sm" style="text-transform: unset !important;" pInputText type="text" [(ngModel)]="dadosMedico.email" placeholder="ex: contato@email.com">
                </div>
            </div>

            <!-- ENDEREÇO -->
            <div class="formgrid grid m-0 p-fluid mt-4">
                <!-- CEP -->
                <div class="field col-12 lg:col-2 mb-2">
                    <label>CEP</label>
                    <p-inputMask class="p-inputtext-sm" mask="99999-999" [(ngModel)]="dadosMedico.endereco.cep" (onComplete)="buscarEnderecoMedico()" />
                </div>

                <!-- Logradouro -->
                <div class="field col-12 lg:col-6 mb-2">
                    <label>Logradouro</label>
                    <input [disabled]="enderecoMedicoLoading" [(ngModel)]="dadosMedico.endereco.logradouro" pInputText type="text" class="inputP">
                </div>

                <!-- Número -->
                <div class="field col-12 lg:col-2 mb-2">
                    <label>Número</label>
                    <input [(ngModel)]="dadosMedico.endereco.numero" pInputText type="text" class="inputP">
                </div>

                <!-- Complemento -->
                <div class="field col-12 lg:col-2 mb-2">
                    <label>Complemento</label>
                    <input [(ngModel)]="dadosMedico.endereco.complemento" pInputText type="text" class="inputP">
                </div>

                <!-- Bairro -->
                <div class="field col-12 lg:col-4 mb-2">
                    <label>Bairro</label>
                    <input [disabled]="enderecoMedicoLoading" [(ngModel)]="dadosMedico.endereco.bairro" maxlength="30" pInputText type="text" class="inputP">
                </div>

                <!-- Cidade -->
                <div class="field col-12 lg:col-8 mb-2">
                    <label>Cidade</label>
                    <p-autoComplete
                        [disabled]="enderecoMedicoLoading"
                        class="p-inputtext-sm"
                        [(ngModel)]="dadosMedico.endereco.cod_cidade"
                        [suggestions]="listagemCidadesMedico"
                        optionLabel="nome"
                        (completeMethod)="buscarCidadesMedico($event)"
                        placeholder="Pesquise uma cidade..."
                        [showClear]="true"
                        [virtualScroll]="!!listagemCidadesMedico && listagemCidadesMedico.length > 38"
                        [virtualScrollItemSize]="38"
                        [style]="{'width':'100%'}"
                        [inputStyle]="{'width':'100%'}"
                        [styleClass]="'text-sm'"
                        [showEmptyMessage]="true"
                        emptyMessage="Nenhuma cidade encontrada">
                        <ng-template let-cidade pTemplate="selectedItem">
                            <div class="flex align-items-center gap-2" *ngIf="cidade">
                                <div>{{ cidade.nome }}</div>
                            </div>
                        </ng-template>
                        <ng-template let-cidade pTemplate="item">
                            <div class="flex align-items-center gap-2" *ngIf="cidade">
                                <div>{{ cidade.nome }}</div>
                            </div>
                        </ng-template>
                    </p-autoComplete>
                </div>
            </div>
        </p-fieldset>
    </div>

    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" (click)="salvarMedico()" label="Salvar" [disabled]="loadingMedico"></p-button>
        <p-button icon="pi pi-times" (click)="modalCadastrarMedico = false" label="Fechar" [disabled]="loadingMedico"></p-button>
    </ng-template>
</p-dialog>